// The line under a friend's name in the profile sidebar, from the activity GET /friendships sends.
const line = (...parts) => parts.filter(Boolean).join(' · ');

export default function friendStatus(t, friend, viewerUuid) {
  const a = friend.activity;
  const key = (name, params) => t(`v5_ui_shell.status.${name}`, params);

  switch (a?.type) {
    case 'match': {
      const start = a.lan_party ? key('lan_match') : key('match', { mode: a.mode });
      return line(start, a.map, a.score?.join('-'));
    }
    case 'server':
      if (a.scrim) return line(key('scrim'), a.map);
      return line(a.mod ? key('practicing', { mod: a.mod }) : key('on_server'), a.map);
    case 'party':
      if (a.owner_uuid === viewerUuid) return key('your_party');
      if (a.owner_uuid === friend.uuid) return key('own_party', { n: a.size });
      return key('party', { name: a.owner_name });
    case 'lan_party':
      return key('lan_party', { name: a.host });
    case 'match_found':
    case 'veto':
    case 'joining_match':
    case 'queue':
      return key(a.type);
    default:
      return t('v5_ui_shell.online_status');
  }
}
